// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.check__owner {\n  position: fixed;\n  top: 5px;\n  width: 40%;\n  z-index: 100;\n  background-color: rgb(245, 133, 133);\n}\n.check__owner h1 {\n  font-size: 18px;\n  align-self: center;\n  color: rgb(36, 35, 35);\n}\n", ""]);
// Exports
module.exports = exports;
